<div class="news-details" *ngIf="newsContent">
  <div class="row">
    <div class="col s12 m12 l12 xl12">
      <h2>{{newsContent.title}}</h2>
      <p class="block-with-text" [innerHTML]="newsContent.newsDetails ? newsContent.newsDetails : ''"></p>
    </div>
  </div>
  <div class="row">
    <div class="col s12 m6 l6">
      <button class="btn waves-effect" type="button" (click)="goToHome()">
        <span class="k-icon k-i-arrow-chevron-left"></span>
        <span class="bold">Home</span>
      </button>
    </div>
    <div class="col s12 m6 l6 align-right">
      <button class="btn waves-effect" type="button" (click)="scrollToTop()">
        <span class="k-icon k-i-arrow-up"></span>
        <span class="bold">Top</span>
      </button>
    </div>
  </div>
</div>
<app-notification-loading></app-notification-loading>
